import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { pluralizeStringWithQuantity } from '@/utils/stringTransformations';

type TCartItemListHeaderProps = {
	headerLabel: string;
	headerCount: number;
};

const CartItemListHeader = (props: TCartItemListHeaderProps) => {
	return (
		<FlexBox
			className='cursor-pointer'
			p='24px 32px'
			sx={{ backgroundColor: getColor('Minty -4') }}
		>
			<FlexBox alignItems={'center'}>
				<LencoTypography
					mr='8px'
					variant='H14_Medium'
					color={getColor('Gray 0')}
				>
					{props.headerLabel}
				</LencoTypography>
				<LencoTypography
					variant='Small_Regular'
					color={getColor('Gray 0')}
					sx={{ lineHeight: '12px' }}
				>
					{pluralizeStringWithQuantity(props.headerCount, 'item')}
				</LencoTypography>
			</FlexBox>
		</FlexBox>
	);
};

export default CartItemListHeader;
